import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { BACKEND_URL } from '../config';

const httpLink = createHttpLink({
  uri: `${BACKEND_URL.replace(/\/$/, '')}/graphql`,
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});

export default client;
